/**
 * Wemond V84 overrides for Shopify.actions:
 * - updateCart: emit globally so the Ritual mini cart can refresh from every add source.
 * - openCart: open the Wemond mini cart instead of the native drawer.
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document,
  });

  actions.openCart.configure({
    async handler() {
      if (window.WemondMiniCart?.open) {
        await window.WemondMiniCart.open();
        return;
      }
      window.location.href = Theme.routes.cart_url || '/cart';
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
